import React from 'react';
import { Auth } from 'aws-amplify';
import ReactDOM from 'react-dom';
import Amplify from 'aws-amplify';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

fetch("/config.json", {cache: "no-cache"}).then(
  response => response.json()
).then(config => {
  config.Amplify.API.graphql_headers = async () => { 
    return { Authorization: (await Auth.currentSession()).getIdToken().getJwtToken() }
  }
  Amplify.configure(config.Amplify);
  ReactDOM.render(<App />, document.getElementById('root'));
});


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
